'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdAutorenew = function MdAutorenew(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.3 12.9c1.3 2 2.1 4.5 2.1 7.1 0 7.3-6.1 13.4-13.4 13.4v5l-6.6-6.8 6.6-6.6v5c5.5 0 10-4.4 10-10 0-1.7-0.5-3.3-1.2-4.7z m-11.3-2.9c-5.5 0-10 4.5-10 10 0 1.7 0.4 3.3 1.2 4.7l-2.4 2.4c-1.4-2-2.2-4.5-2.2-7.1 0-7.3 6.1-13.4 13.4-13.4v-5l6.6 6.8-6.6 6.6v-5z' })
        )
    );
};

exports.default = MdAutorenew;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/autorenew.js
// module id = 760
// module chunks = 36573943044255 79611799117203 213534597649335